import React from 'react';
import './Footer.css';
import { Mail, Github, Linkedin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="contact" className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-logo">NA Code Studio</h3>
            <p className="footer-description">
              Crafting digital excellence through innovative solutions and creative development.
            </p>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Quick Links</h4>
            <ul className="footer-links">
              <li><a href="#hero">Home</a></li>
              <li><a href="#about">About</a></li>
              <li><a href="#projects">Projects</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Connect</h4>
            <div className="social-links">
              <a 
                href="mailto:naelamen@gmail.com" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="Email"
                className="social-link"
              >
                <Mail size={20} />
              </a>
              <a 
                href="https://github.com/naelaburomii" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="GitHub"
                className="social-link"
              >
                <Github size={20} />
              </a>
              <a 
                href="https://www.linkedin.com/in/nael-abu-romii-a4a0a8229" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="social-link"
              >
                <Linkedin size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} NA Code Studio. All rights reserved.</p>
          <div className="footer-legal-links">
            <a href="/ameer-barber/support" target="_blank" rel="noopener noreferrer">
              Ameer Barber Support
            </a>
            <a href="/ameer-barber/privacy" target="_blank" rel="noopener noreferrer">
              Ameer Barber Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;



